import { isNativePlatform } from './lib/capacitor';

export function register() {
  // Don't register service worker on native Capacitor — it causes stale content
  // issues when users update the app from the store. Capacitor handles its own caching.
  if (isNativePlatform()) {
    unregister();
    return;
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(() => {})
        .catch(() => {});
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch(() => {});
  }
}
